<app-complex-modal-template
    [canCancel]="true"
    [canConfirm]="true"
    [confirmLabel]="'save'"
    [title]="'contextLayers' | transloco"
    (onCancelClick)="cancel()"
    (onClickEvent)="onModalResult($event)">
    <div class="flex flex-col gap-4 p-2">
        <app-field-intervention-context-layers
            [contextLayersOptions]="data.options"
            [contextLayersSelected]="selectedOptions()"
            [displayMode]="FieldInterventionContextLayersDisplayModeEnum.EDITABLE"
            (selectionChange)="onSelectionChange($event)" />
    </div>
</app-complex-modal-template>
